import {yupResolver} from '@hookform/resolvers/yup'
import {SnackbarProvider} from 'notistack'
import {FC, useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {Panel, PanelGroup} from 'react-resizable-panels'
import Swal from 'sweetalert2'
import {useHoteleria} from '../../../../hooks/useHoteleria'
import {TabModel} from '../../../../models'
import {getSnackBar, getSnackBarToast} from '../../../../util/snackBar'
import ContainerWrapper from '../../../central/pages/componentes/Container'
import {ResizeHandle} from '../../components/Layout/Container/ResizeHandle/ResizeHandle'
import {renderPanelContent} from '../../components/components'
import {ModuleModel} from '../../features/modules/models'
import {BookingModel} from '../../models/booking.model'
import {bookingSchema} from '../../schemas'
import {createBookingService, deleteBookingService} from '../../services/booking.service'
import ActionsContent from '../components/Actions'
import {formatDateDDMMYYYY} from '../../../../util/dates'
const BookingPageWrapper: FC = () => {
  const {currentTabItem, changeCurrentTabItem} = useHoteleria()
  const [loading, setLoading] = useState(false)
  const methods = useForm<BookingModel>({
    resolver: yupResolver(bookingSchema),
  })

  const handleDelete = async () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Al eliminar, no podrás revertir esta acción',
      //showDenyButton: true,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, eliminar',
      confirmButtonColor: 'var(--kt-primary)',
      //denyButtonText: `Don't save`,
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        setLoading(true)
        let id = [{Id: currentTabItem.idToDelete}]
        changeCurrentTabItem({...currentTabItem, loadingTable: true, deleted: false})
        const data = await deleteBookingService(id)
        if (!data.data.error) {
          setLoading(false)
          const obj: TabModel = {
            ...currentTabItem,
            idToDelete: '',
            loadingTable: false,
            deleted: true,
          }
          changeCurrentTabItem(obj)
          getSnackBarToast('Se eliminó con éxito', 'success')
        } else {
          setLoading(false)
          changeCurrentTabItem({...currentTabItem, loadingTable: false, deleted: false})
          getSnackBarToast(data.data.message, 'error')
        }
        Swal.close()
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }

  const onSubmit = async (data: ModuleModel) => {
    try {
      setLoading(true)
      const response = await createBookingService(data)

      if (!response.data.error) {
        console.log('aqui?', response.data)
        data.FechaFin = formatDateDDMMYYYY(data.FechaFin)
        data.FechaInicio = formatDateDDMMYYYY(data.FechaInicio)
        setLoading(false)
        getSnackBarToast('Se creó con éxito', 'success')
        const obj: TabModel = {
          ...currentTabItem,
          showPanel: true,
          noFormDetail: true,
          content: {
            headerPanel: 'header-bookings',
            detailPanel: 'detail-bookings',
          },
          idToEdit: response.data.ReservaId as any,
          objectInfo: data,
        }
        changeCurrentTabItem(obj)
      } else {
        getSnackBarToast(response.data.message, 'error')
        setLoading(false)
      }
    } catch (error) {
      console.log('o aqui?')

      getSnackBarToast('Hubo un error interno', 'error')
      setLoading(false)
    }
  }

  console.log('currentTabItem', currentTabItem)
  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <ActionsContent
          deleteClick={handleDelete}
          loading={loading}
          textComponentBack='header-bookings'
          textComponentGo='form-bookings'
        />
        <ContainerWrapper>
          <PanelGroup autoSaveId='example' direction='vertical'>
            <Panel
              collapsible={true}
              order={1}
              key={`panel-hoteleria-header-${currentTabItem.title}`}
              id={`panel-hoteleria-header-${currentTabItem.title}`}
              className={'panel__box'}
            >
              {renderPanelContent(currentTabItem.content.headerPanel)}
            </Panel>
            {currentTabItem.showPanel && (
              <>
                <ResizeHandle />
                <Panel
                  className={'panel__box'}
                  collapsible={true}
                  defaultSize={50}
                  order={2}
                  key={`panel-hoteleria-detail-${currentTabItem.title}`}
                  id={`panel-hoteleria-detail-${currentTabItem.title}`}
                >
                  {renderPanelContent(currentTabItem.content.detailPanel)}
                </Panel>
              </>
            )}
          </PanelGroup>
          <SnackbarProvider />
        </ContainerWrapper>
      </form>
    </FormProvider>
  )
}

export {BookingPageWrapper}
